<template>
  <Breadcrumb :items="breadcrumbItems" />

  <div class="header-menu-acoes">
    <h2 class="titulo-pagina">Ações de Extensão</h2>
    <div class="header-actions">
      <button
        class="btn-toggle-encerradas"
        @click="exibirEncerradas = !exibirEncerradas"
        :class="{ ativa: exibirEncerradas }"
      >
        <i
          class="ti ti-archive"
          v-if="!exibirEncerradas"
        ></i>
        <i
          class="ti ti-list"
          v-else
        ></i>
        <span>{{
          exibirEncerradas ? "Ver ações ativas" : "Ver ações encerradas"
        }}</span>
      </button>
      <FiltrosComponent
        :nomeTela="'acao'"
        :isCoordenador="false"
        :filtrosIniciais="{ unidadeId: filtroUnidadeId }"
        @aplicarFiltros="onAplicarFiltros"
        @pesquisar="onPesquisar"
      />
    </div>
  </div>

  <Carregamento v-if="loading" />

  <div v-else-if="!acaoSelecionada">
    <!-- MINHAS AÇÕES -->
    <div
      class="secao-acoes"
      v-if="!estaPesquisando"
    >
      <h3 class="subtitulo-secao">Minhas Ações</h3>
      <div v-if="!exibirEncerradas">
        <div
          class="conteudo"
          v-for="(acao, index) in minhasAcoesAtivas"
          :key="index"
          @click="abrirAcao(acao)"
        >
          <div class="imagem-conteudo-acao">
            <img
              v-if="acao.imagemUrl"
              :src="acao.imagemUrl"
              alt="Imagem da Ação"
              loading="lazy"
              decoding="async"
            />
            <img
              v-else
              src="@/assets/logoGex1.2.png"
              alt="Logo GEX"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="conteudo-listagem-acao">
            <div class="cima-conteudo-acao">
              <h5>
                {{ acao.titulo }}
                <span
                  v-if="acao.dataInicio || acao.dataFim"
                  style="font-size: 0.8em; font-weight: normal"
                >
                  - Período: {{ formatarData(acao.dataInicio) }} a
                  {{ formatarData(acao.dataFim) }}</span
                >
              </h5>
              <p class="descricao-texto">
                <b>Descrição: </b>
                {{ acao.descricao || "Sem descrição informada." }}
              </p>
            </div>
            <div class="baixo-conteudo-acao">
              <p>
                <b>Área Temática: </b>
                {{ acao.areaTematica || "Não informada" }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="minhasAcoesAtivas.length === 0"
          class="sem-acoes"
        >
          <p>Nenhuma ação ativa encontrada.</p>
        </div>
      </div>
      <div v-else>
        <div
          class="conteudo"
          v-for="(acao, index) in minhasAcoesEncerradas"
          :key="index"
          @click="abrirAcao(acao)"
        >
          <div class="imagem-conteudo-acao">
            <img
              v-if="acao.imagemUrl"
              :src="acao.imagemUrl"
              alt="Imagem da Ação"
              loading="lazy"
              decoding="async"
            />
            <img
              v-else
              src="@/assets/logoGex1.2.png"
              alt="Logo GEX"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="conteudo-listagem-acao">
            <div class="cima-conteudo-acao">
              <h5>
                {{ acao.titulo }}
                <span
                  v-if="acao.dataInicio || acao.dataFim"
                  style="font-size: 0.8em; font-weight: normal"
                >
                  - Período: {{ formatarData(acao.dataInicio) }} a
                  {{ formatarData(acao.dataFim) }}</span
                >
              </h5>
              <p class="descricao-texto">
                <b>Descrição: </b>
                {{ acao.descricao || "Sem descrição informada." }}
              </p>
            </div>
            <div class="baixo-conteudo-acao">
              <p>
                <b>Área Temática: </b>
                {{ acao.areaTematica || "Não informada" }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="minhasAcoesEncerradas.length === 0"
          class="sem-acoes"
        >
          <p>Nenhuma ação encerrada encontrada.</p>
        </div>
      </div>
    </div>

    <!-- OUTRAS AÇÕES -->
    <div
      class="secao-acoes"
      style="margin-top: 40px"
    >
      <h3 class="subtitulo-secao">
        {{ exibirEncerradas ? "Outras Ações Encerradas" : "Outras Ações" }}
      </h3>
      <div v-if="!exibirEncerradas">
        <div
          class="conteudo"
          v-for="(acao, index) in outrasAcoesAtivas"
          :key="'outras-' + index"
          @click="abrirAcao(acao)"
        >
          <div class="imagem-conteudo-acao">
            <img
              v-if="acao.imagemUrl"
              :src="acao.imagemUrl"
              alt="Imagem da Ação"
              loading="lazy"
              decoding="async"
            />
            <img
              v-else
              src="@/assets/logoGex1.2.png"
              alt="Logo GEX"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="conteudo-listagem-acao">
            <div class="cima-conteudo-acao">
              <h5>
                {{ acao.titulo }}
                <span
                  v-if="acao.dataInicio || acao.dataFim"
                  style="font-size: 0.8em; font-weight: normal"
                >
                  - Período: {{ formatarData(acao.dataInicio) }} a
                  {{ formatarData(acao.dataFim) }}</span
                >
              </h5>
              <p class="descricao-texto">
                <b>Descrição: </b>
                {{ acao.descricao || "Sem descrição informada." }}
              </p>
            </div>
            <div class="baixo-conteudo-acao">
              <p>
                <b>Área Temática: </b>
                {{ acao.areaTematica || "Não informada" }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="outrasAcoesAtivas.length === 0"
          class="sem-acoes"
        >
          <p>Nenhuma outra ação ativa encontrada.</p>
        </div>
      </div>
      <div v-else>
        <div
          class="conteudo"
          v-for="(acao, index) in outrasAcoesEncerradas"
          :key="'outras-encerradas-' + index"
          @click="abrirAcao(acao)"
        >
          <div class="imagem-conteudo-acao">
            <img
              v-if="acao.imagemUrl"
              :src="acao.imagemUrl"
              alt="Imagem da Ação"
              loading="lazy"
              decoding="async"
            />
            <img
              v-else
              src="@/assets/logoGex1.2.png"
              alt="Logo GEX"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="conteudo-listagem-acao">
            <div class="cima-conteudo-acao">
              <h5>
                {{ acao.titulo }}
                <span
                  v-if="acao.dataInicio || acao.dataFim"
                  style="font-size: 0.8em; font-weight: normal"
                >
                  - Período: {{ formatarData(acao.dataInicio) }} a
                  {{ formatarData(acao.dataFim) }}</span
                >
              </h5>
              <p class="descricao-texto">
                <b>Descrição: </b>
                {{ acao.descricao || "Sem descrição informada." }}
              </p>
            </div>
            <div class="baixo-conteudo-acao">
              <p>
                <b>Área Temática: </b>
                {{ acao.areaTematica || "Não informada" }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="outrasAcoesEncerradas.length === 0"
          class="sem-acoes"
        >
          <p>Nenhuma outra ação encerrada encontrada.</p>
        </div>
      </div>

      <div v-if="totalOutrasPaginas > 1">
        <PaginacaoComponent
          :total-paginas="totalOutrasPaginas"
          :pagina-atual="paginaOutras"
          @mudar-pagina="mudarPaginaOutras"
        />
      </div>
    </div>
  </div>

  <div v-if="acaoSelecionada">
    <AcaoView @atualizarTitulo="emit('paginaAberta', true)" />
  </div>

  <ModalEditarSigla
    :mostrar="modalSiglaVisivel"
    :acaoId="acaoSelecionadaParaEdicao?.acao_id"
    :siglaAtual="acaoSelecionadaParaEdicao?.sigla"
    :corAtual="acaoSelecionadaParaEdicao?.corSigla"
    @fechar="fecharModalSigla"
    @atualizado="buscarAcoes"
  />
</template>

<script>
export default { name: "MenuAcoesView" };
</script>
<script setup>
import AcaoView from "@/views/acoes/AcaoView.vue";
import ModalEditarSigla from "@/components/acoes/ModalEditarSigla.vue";
import {
  ref,
  computed,
  watchEffect,
  watch,
  onMounted,
  getCurrentInstance,
} from "vue";
import usuariosService from "@/service/usuariosService";
import acaoService from "@/service/acaoService";
import { useRoute, useRouter } from "vue-router";
import FiltrosComponent from "@/components/common/FiltrosComponent.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import PaginacaoComponent from "@/components/common/paginacaoComponent.vue";
import { formatarData } from "@/utils/FormatarEntradas.js";
import userInfos from "@/utils/userInfos";

const emit = defineEmits(["paginaAberta"]);
const props = defineProps({
  isAtiva: Boolean,
});
const { proxy } = getCurrentInstance();

const loading = ref(false);
const loadingMais = ref(false);
const router = useRouter();
const route = useRoute();

const exibirEncerradas = ref(false);
const acaoSelecionada = ref(false);
const acaoAtiva = ref(null);

const minhasAcoes = ref([]);
const outrasAcoes = ref([]);

const paginaOutras = ref(Number(route.query.page) || 0);
const tamanhoPagina = 10;
const totalOutrasPaginas = ref(1);

const filtroUnidadeId = ref(null);
const termoBusca = ref("");

const modalSiglaVisivel = ref(false);
const acaoSelecionadaParaEdicao = ref(null);

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Ações", to: "/suas-acoes" },
  ];
});

function abrirModalSigla(acao) {
  acaoSelecionadaParaEdicao.value = acao;
  modalSiglaVisivel.value = true;
}

function fecharModalSigla() {
  modalSiglaVisivel.value = false;
  acaoSelecionadaParaEdicao.value = null;
}

watchEffect(() => {
  if (!props.isAtiva) {
    acaoSelecionada.value = false;
    emit("paginaAberta", false);
  }
});

watch(
  () => route.query.page,
  (newPage) => {
    const pagina = Number(newPage) || 0;
    paginaOutras.value = pagina;
    buscarOutrasAcoes(pagina);
  }
);

watch(exibirEncerradas, (val) => {
  paginaOutras.value = 0;
  buscarOutrasAcoes(0);
  router.replace({ query: { ...route.query, page: 0 } }).catch(() => {});
});

function abrirAcao(acao) {
  const idAcao = acao.acao_id || acao.id;
  acaoAtiva.value = acao;
  acaoSelecionada.value = true;
  emit("paginaAberta", true);
  router.push({
    name: "acao-default",
    params: { id: idAcao },
  });
}

function fecharAcao() {
  acaoAtiva.value = null;
  acaoSelecionada.value = false;
  emit("paginaAberta", false);
}

function isEncerrada(acao) {
  if (
    acao.status === "ENCERRADA" ||
    acao.encerrada === true ||
    acao.ativo === false
  )
    return true;
  if (acao.dataFim) {
    return new Date(acao.dataFim) < new Date();
  }
  return false;
}

const minhasAcoesAtivas = computed(() =>
  minhasAcoes.value.filter((a) => !isEncerrada(a))
);
const minhasAcoesEncerradas = computed(() =>
  minhasAcoes.value.filter((a) => isEncerrada(a))
);

const outrasAcoesAtivas = computed(() =>
  outrasAcoes.value.filter((a) => !isEncerrada(a))
);
const outrasAcoesEncerradas = computed(() =>
  outrasAcoes.value.filter((a) => isEncerrada(a))
);

const temMaisOutrasAcoes = computed(
  () => paginaOutras.value + 1 < totalOutrasPaginas.value
);

const estaPesquisando = computed(
  () => !!termoBusca.value || !!filtroUnidadeId.value
);

async function buscarMinhasAcoes() {
  try {
    const acoesUsuario = await usuariosService.getAcoesUsuario();
    if (acoesUsuario && Array.isArray(acoesUsuario)) {
      const user = userInfos.getUserInfos();
      const userName = user ? user.nome : "";
      minhasAcoes.value = acoesUsuario
        .map((acao) => {
          acao.titulo = acao.titulo?.replace(/"/g, "") || "Sem título";
          return acao;
        })
        .sort((a, b) => {
          const aIsCoord = a.nomeCoordenador === userName ? 1 : 0;
          const bIsCoord = b.nomeCoordenador === userName ? 1 : 0;
          return bIsCoord - aIsCoord;
        });
    }
  } catch (error) {
    console.error("Erro ao buscar minhas ações:", error);
  }
}

async function buscarOutrasAcoes(pagina = 0) {
  loadingMais.value = true;
  try {
    const response = await acaoService.getAcoesFiltro(
      pagina,
      tamanhoPagina,
      filtroUnidadeId.value,
      exibirEncerradas.value ? "ENCERRADA" : "ATIVA",
      termoBusca.value || null
    );
    if (response && response.content) {
      let novasAcoes = response.content.map((acao) => {
        acao.titulo = acao.titulo?.replace(/"/g, "") || "Sem título";
        return acao;
      });

      outrasAcoes.value = novasAcoes;
      totalOutrasPaginas.value = response.totalPages || 1;
      paginaOutras.value = response.number || pagina;
    }
  } catch (error) {
    console.error("Erro ao buscar outras ações:", error);
  } finally {
    loadingMais.value = false;
  }
}

function mudarPaginaOutras(pagina) {
  const query = { ...route.query, page: pagina };
  router.push({ query });
}

async function buscarAcoes() {
  loading.value = true;
  await buscarMinhasAcoes();
  await buscarOutrasAcoes(paginaOutras.value);
  loading.value = false;
}

function onAplicarFiltros(filtros) {
  filtroUnidadeId.value = filtros.unidadeId || null;
  paginaOutras.value = 0;
  buscarOutrasAcoes(0);
  router.replace({ query: { ...route.query, page: 0 } }).catch(() => {});
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function onPesquisar(texto) {
  termoBusca.value = texto;
  paginaOutras.value = 0;
  buscarOutrasAcoes(0);
  router.replace({ query: { ...route.query, page: 0 } }).catch(() => {});
  window.scrollTo({ top: 0, behavior: "smooth" });
}

onMounted(async () => {
  await buscarAcoes();
});
</script>

<style scoped>
.titulo-pagina {
  padding-bottom: 0;
  margin: 0;
}

.subtitulo-secao {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.sem-acoes {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  text-align: center;
  color: #666;
}

.sem-acoes p {
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
}

.conteudo-acao {
  background-color: rgb(72, 42, 137);
  margin-bottom: 2%;
  border-radius: 2rem;
  box-shadow: 0 4px 2px rgba(72, 42, 137, 0.45);
}

.header-menu-acoes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 15px;
  border-bottom: 1px solid lightgray;
  width: 100%;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-actions :deep(.barra-acoes) {
  border-bottom: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.btn-toggle-encerradas {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: var(--branco, #fff);
  color: var(--roxo-escuro1, #563578);
  border: 1px solid var(--roxo-escuro1, #563578);
  border-radius: 5px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-toggle-encerradas:hover {
  background-color: #f8f6fc;
}

.btn-toggle-encerradas.ativa {
  background-color: var(--roxo-escuro1, #563578);
  color: #fff;
  border-color: var(--roxo-escuro1, #563578);
}

.btn-toggle-encerradas.ativa:hover {
  background-color: #482a89;
}

.btn-toggle-encerradas i {
  font-size: 18px;
}

.conteudo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  box-shadow: none;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(217, 217, 217, 1);
  margin-bottom: 2%;
  border-radius: 0.5rem;
  cursor: pointer;
  padding: 30px 20px;
  transition: 200ms;
  position: relative;
}

.conteudo p {
  font-size: 15px;
  color: black;
  margin: 0;
}

.conteudo:hover {
  transform: scale(1.01);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
}

.imagem-conteudo-acao {
  height: 100%;
  width: 283px;
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: #563578;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.imagem-conteudo-acao img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.descricao-texto {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal;
  text-align: left;
  line-height: 1.4;
}

.conteudo-listagem-acao {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: none;
  height: 100%;
  width: 100%;
  border-radius: 1.95rem;
  text-align: left;
  font-weight: 500;
  color: black;
  padding: 0px 15px;
  font-size: 1.95rem;
  position: relative;
}

.btn-configuracoes {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 36px !important;
  height: 36px !important;
  background: none;
  border: none;
  cursor: pointer;
  color: #482a89;
  padding: 0 !important;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition:
    transform 0.2s,
    color 0.2s;
}

.btn-configuracoes:hover {
  transform: scale(1.15) rotate(20deg);
  color: #563578;
}

.carregar-mais-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.btn-carregar-mais {
  padding: 10px 24px;
  background-color: #563578;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-carregar-mais:hover:not(:disabled) {
  background-color: #3b1f8c;
}

.btn-carregar-mais:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
